import React from 'react'
import { BLOCKS, MARKS, INLINES } from '@contentful/rich-text-types'
import { UP,LEFT } from '../components/blurb'
export const size = {
    sm : "37.5em",   //600  px
    ms : "48em",     //768  px
    md : "56.25em",  //900  px
    lg : "75em",     //1200 px
    xl : "93.75em",  //1500 px
    xxl : "112.5em", //1800 px
}

export const breakpoints = {
    sm : `@media only screen and (max-width: ${size.sm})`,
    ms : `@media only screen and (max-width: ${size.ms})`,
    md : `@media only screen and (max-width: ${size.md})`,
    lg : `@media only screen and (max-width: ${size.lg})`,
    xl : `@media only screen and (min-width: ${size.xl})`,
    xxl : `@media only screen and (min-width: ${size.xxl})`,
}

export const colors = {
    primary : "#2E008B",
    secondary : "#64A70B",
    tertiary : "#FFFFFF",
    quaternary : "#000000",
    quinary : "#F0F0F0",
    senary : "#1D0E5C",
    septenary : "#0C0026EB",
    success : "#0D8E00",
    error : "#B00000",
    validoPrimary : "#00E87E",
    validoSecondary : "#2E00BF"
}

export const richTextOptions2 = {
    renderMark: {
        [MARKS.BOLD]: text => <b>{text}</b>,
        [MARKS.ITALIC]: text => <i>{text}</i>,
        [MARKS.UNDERLINE]: text => <u>{text}</u>,
        [MARKS.CODE]: text => <code>{text}</code>
      },
    renderNode: {
        [BLOCKS.EMBEDDED_ENTRY]: (children) => {
            const { icon, content } = children.data.target.fields;
            switch (children.data.target.sys.contentType.sys.id){
                case "blurbIconUp" :    
                    return (<UP   icon={icon.es.fields.file.es.url} content={content.es.content[0].content[0].value} />);
                case "blurbIconLeft" :  
                    return (<LEFT icon={icon.es.fields.file.es.url} content={content.es.content[0].content[0].value} />);
                default: return
            };
        },
        [INLINES.EMBEDDED_ENTRY]: (children) => {
            const { icon, content } = children.data.target.fields;
            return <UP icon={icon.es.fields.file.es.url} content={content.es.content[0].content[0].value} />
        }
    },
    renderText: text => text.replace('!', '?'),    
}

export const richTextOptions = {
    renderMark: {
        [MARKS.BOLD]: text => <b>{text}</b>,
        [MARKS.ITALIC]: text => <i>{text}</i>,
        [MARKS.UNDERLINE]: text => <u>{text}</u>,
        [MARKS.CODE]: text => <code>{text}</code>
    },
    renderNode: {
        [INLINES.HYPERLINK]: (children) => {
            return <a href={children.data.uri} target="_blank" rel="noreferrer">{children.content[0].value}</a>
        }
    }
};

export const transitions = {
    button : "transform .5s ease-in-out"
}